import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-icons/font/bootstrap-icons.scss';
import './styles/custom.scss';

// FONTOS: a bundle-t importáld, ebben benne van a Popper is
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

// (opcionális) ha kell neked globálisan is:
(window as any).bootstrap = bootstrap;

import AOS from "aos";
import "aos/dist/aos.css";
// Ambrus Autóház – homepage interactions
// Requires: Bootstrap 5 JS + AOS
/* global bootstrap, AOS */
(function () {
  const qs = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  // AOS init
  if (window.AOS) {
    AOS.init({
      duration: 650,
      once: true,
      easing: "ease-out-cubic",
      offset: 70
    });
  }

  // Navbar shrink on scroll
  const navbar = qs(".gsc-navbar");
  const onScroll = () => {
    if (!navbar) return;
    navbar.classList.toggle("is-shrink", window.scrollY > 10);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // Smooth scroll helper
  const smoothScrollTo = (targetSel) => {
    const el = typeof targetSel === "string" ? qs(targetSel) : targetSel;
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // data-gsc-scroll buttons
  qsa("[data-gsc-scroll]").forEach((btn) => {
    btn.addEventListener("click", () => smoothScrollTo(btn.getAttribute("data-gsc-scroll")));
  });

  // Active nav link highlight (simple)
  const sections = ["#szolgaltatasok", "#technologia", "#referenciak", "#galeria", "#kapcsolat"]
    .map((id) => qs(id))
    .filter(Boolean);

  const navLinks = qsa(".navbar .nav-link");

  const setActiveLink = () => {
    let currentId = "";
    const y = window.scrollY + 120;
    for (const sec of sections) {
      const top = sec.offsetTop;
      const bottom = top + sec.offsetHeight;
      if (y >= top && y < bottom) currentId = "#" + sec.id;
    }
    navLinks.forEach((a) => {
      const href = a.getAttribute("href");
      a.classList.toggle("active", href === currentId);
    });
  };
  window.addEventListener("scroll", setActiveLink, { passive: true });
  setActiveLink();

  // Button ripple micro-animation
  const addRipple = (el, x, y) => {
    const r = document.createElement("span");
    r.className = "gsc-ripple";
    const rect = el.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    r.style.width = r.style.height = size + "px";
    r.style.left = (x - rect.left - size / 2) + "px";
    r.style.top = (y - rect.top - size / 2) + "px";
    el.appendChild(r);
    setTimeout(() => r.remove(), 520);
  };

  // inject ripple CSS (tiny, so you don't need extra file)
  const rippleStyle = document.createElement("style");
  rippleStyle.textContent = `
    .gsc-ripple{
      position:absolute;
      border-radius:999px;
      transform: scale(0);
      animation: gscRipple .52s ease-out;
      background: rgba(255,255,255,.22);
      pointer-events:none;
      mix-blend-mode: screen;
    }
    @keyframes gscRipple{
      to { transform: scale(1); opacity: 0; }
    }
  `;
  document.head.appendChild(rippleStyle);

  qsa(".gsc-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // only for left click / tap
      if (e.type === "click") addRipple(btn, e.clientX, e.clientY);
    });
  });

  // Lightbox
  const lightboxEl = qs("#gscLightbox");
  const lightboxImg = qs("#gscLightboxImg");
  const lightboxTitle = qs("#gscLightboxTitle");
  const lightboxMeta = qs("#gscLightboxMeta");
  const lightboxPrev = qs("#gscLightboxPrev");
  const lightboxNext = qs("#gscLightboxNext");
  const lightbox = lightboxEl ? new bootstrap.Modal(lightboxEl) : null;
  const lightboxItems = qsa(".gsc-open-lightbox");
  let currentLightboxIndex = 0;

  const renderLightbox = (index) => {
    if (!lightboxItems.length) return;

    if (index < 0) index = lightboxItems.length - 1;
    if (index >= lightboxItems.length) index = 0;
    currentLightboxIndex = index;

    const current = lightboxItems[currentLightboxIndex];
    const img = current.getAttribute("data-img");
    const title = current.getAttribute("data-title") || "Kép";

    if (lightboxImg) {
      lightboxImg.src = img || "";
      lightboxImg.alt = title;
    }

    if (lightboxTitle) lightboxTitle.textContent = title;
    if (lightboxMeta) lightboxMeta.textContent = `${currentLightboxIndex + 1} / ${lightboxItems.length}`;
  };

  lightboxItems.forEach((el, index) => {
    el.setAttribute("data-lightbox-index", String(index));
    el.addEventListener("click", (event) => {
      event.preventDefault();
      if (!lightbox) return;
      renderLightbox(index);
      lightbox.show();
    });
  });

  if (lightboxPrev) {
    lightboxPrev.addEventListener("click", () => renderLightbox(currentLightboxIndex - 1));
  }

  if (lightboxNext) {
    lightboxNext.addEventListener("click", () => renderLightbox(currentLightboxIndex + 1));
  }

  if (lightboxImg) {
    lightboxImg.addEventListener("click", () => renderLightbox(currentLightboxIndex + 1));
  }

  document.addEventListener("keydown", (event) => {
    if (!lightboxEl || !lightboxEl.classList.contains("show")) return;
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      renderLightbox(currentLightboxIndex - 1);
    }
    if (event.key === "ArrowRight") {
      event.preventDefault();
      renderLightbox(currentLightboxIndex + 1);
    }
  });

  // Contact form submit + bot protection meta fields
  const form = qs("#gscContactForm");
  if (form) {
    const statusEl = qs("#gscContactStatus", form);
    const startedAtInput = qs('input[name="started_at"]', form);

    const setStartedAt = () => {
      if (startedAtInput) {
        startedAtInput.value = String(Math.floor(Date.now() / 1000));
      }
    };

    const setStatus = (message, isError = false) => {
      if (!statusEl) return;
      statusEl.textContent = message || "";
      statusEl.classList.toggle("text-danger", isError);
      statusEl.classList.toggle("text-success", !isError && !!message);
    };

    setStartedAt();

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      setStatus("");

      if (!form.checkValidity()) {
        form.classList.add("was-validated");
        const firstInvalid = qs(":invalid", form);
        if (firstInvalid) firstInvalid.focus({ preventScroll: true });
        return;
      }

      const submitBtn = qs('button[type="submit"]', form);
      const t = submitBtn ? qs(".gsc-submit-text", submitBtn) : null;
      const l = submitBtn ? qs(".gsc-submit-loading", submitBtn) : null;

      if (submitBtn) submitBtn.disabled = true;
      if (t) t.classList.add("d-none");
      if (l) l.classList.remove("d-none");

      const endpoint = form.getAttribute("action") || "/index/contact";
      const formData = new FormData(form);
      const pageTitle = document.title || "GreenSolarClean";

      formData.set("pageTitle", pageTitle);

      const serviceSelect = qs('select[name="service"]', form);
      if (serviceSelect && serviceSelect.selectedIndex >= 0) {
        const option = serviceSelect.options[serviceSelect.selectedIndex];
        if (option && option.textContent) {
          formData.set("serviceLabel", option.textContent.trim());
          formData.set("topic", option.textContent.trim());
        }
      }

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (_err) {
          payload = null;
        }

        if (!response.ok || !payload || !payload.ok) {
          const errorMessage = payload?.message || "A küldés sikertelen. Kérlek próbáld újra.";
          setStatus(errorMessage, true);
          showToast(errorMessage, "error");
          return;
        }

        const successMessage = payload.message || "Köszönjük! Hamarosan jelentkezünk.";
        setStatus(successMessage, false);
        showToast(successMessage, "success");

        form.reset();
        form.classList.remove("was-validated");
        setStartedAt();
      } catch (_err) {
        const errorMessage = "Hálózati hiba történt. Kérlek próbáld újra.";
        setStatus(errorMessage, true);
        showToast(errorMessage, "error");
      } finally {
        if (submitBtn) submitBtn.disabled = false;
        if (t) t.classList.remove("d-none");
        if (l) l.classList.add("d-none");
      }
    });
  }

  // Simple toast (no extra deps)
  function showToast(message, tone = "success") {
    const icon = tone === "error" ? "bi bi-exclamation-triangle-fill me-2" : "bi bi-check2-circle me-2";
    const wrap = document.createElement("div");
    wrap.className = "gsc-toast";
    wrap.innerHTML = `
      <div class="gsc-toast-inner ${tone === "error" ? "is-error" : "is-success"}">
        <i class="${icon}"></i>
        <div>${escapeHtml(message)}</div>
      </div>
    `;
    document.body.appendChild(wrap);
    requestAnimationFrame(() => wrap.classList.add("is-show"));
    setTimeout(() => wrap.classList.remove("is-show"), 2400);
    setTimeout(() => wrap.remove(), 2900);
  }

  const toastStyle = document.createElement("style");
  toastStyle.textContent = `
    .gsc-toast{
      position: fixed;
      left: 50%;
      bottom: 18px;
      transform: translateX(-50%);
      z-index: 2000;
      opacity: 0;
      transition: opacity .18s ease, transform .18s ease;
      pointer-events:none;
    }
    .gsc-toast.is-show{
      opacity: 1;
      transform: translateX(-50%) translateY(-6px);
    }
    .gsc-toast-inner{
      display:flex;
      align-items:flex-start;
      gap:8px;
      background: rgba(9,12,16,.92);
      border: 1px solid rgba(255,255,255,.14);
      color: rgba(255,255,255,.92);
      padding: 12px 14px;
      border-radius: 999px;
      box-shadow: 0 16px 45px rgba(0,0,0,.35);
      max-width: min(92vw, 520px);
    }
    .gsc-toast-inner.is-error{
      border-color: rgba(255,94,94,.45);
      background: rgba(45,16,16,.94);
    }
  `;
  document.head.appendChild(toastStyle);

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  // Mobile CTA bar — body padding offset so footer isn't covered
  if (qs(".gsc-mobile-cta")) {
    document.body.classList.add("has-mobile-cta");
  }

  // Desktop call-popup with dismissal memory
  const callPopup = qs("#gscCallPopup") as HTMLElement | null;
  if (callPopup) {
    const STORAGE_KEY = "gsc_call_popup_dismissed_at";
    const DISMISS_DAYS = 7;
    const SHOW_AFTER_MS = 3000;
    const SHOW_AFTER_SCROLL = 0.10;

    const dismissedAt = Number(localStorage.getItem(STORAGE_KEY) || 0);
    const dismissed = dismissedAt && (Date.now() - dismissedAt) < DISMISS_DAYS * 86400000;

    if (!dismissed && window.matchMedia("(min-width: 992px)").matches) {
      let shown = false;
      const showPopup = () => {
        if (shown) return;
        shown = true;
        callPopup.classList.add("is-visible");
        callPopup.setAttribute("aria-hidden", "false");
        requestAnimationFrame(() => callPopup.classList.add("is-show"));
      };

      const timer = window.setTimeout(showPopup, SHOW_AFTER_MS);

      const onScrollPopup = () => {
        const scrolled = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
        if (scrolled >= SHOW_AFTER_SCROLL) {
          showPopup();
          window.removeEventListener("scroll", onScrollPopup);
          window.clearTimeout(timer);
        }
      };
      window.addEventListener("scroll", onScrollPopup, { passive: true });

      const closeBtn = qs("#gscCallPopupClose");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          callPopup.classList.remove("is-show");
          callPopup.setAttribute("aria-hidden", "true");
          setTimeout(() => callPopup.classList.remove("is-visible"), 250);
          try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (_e) { /* ignore */ }
        });
      }

      const phoneLink = callPopup.querySelector(".gsc-call-popup-phone");
      if (phoneLink) {
        phoneLink.addEventListener("click", () => {
          try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (_e) { /* ignore */ }
        });
      }
    }
  }

  // Improve anchor clicks in navbar
  qsa('a[href^="#"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      const href = a.getAttribute("href");
      if (!href || href === "#") return;
      const target = qs(href);
      if (!target) return;
      e.preventDefault();
      smoothScrollTo(target);

      // close collapsed navbar on mobile
      const navCollapse = qs("#gscNav");
      if (navCollapse && navCollapse.classList.contains("show")) {
        const bsCollapse = bootstrap.Collapse.getOrCreateInstance(navCollapse);
        bsCollapse.hide();
      }
    });
  });

})();
